import styled from 'styled-components';

import { colors, responsive } from '@/utils';

export const AccordionRoot = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${responsive.spacing.small};
  border-radius: ${responsive.radius.medium};
  /* Must stay visible/unshrinkable: as a flex child of a scrolling column the section
     would otherwise shrink and scroll internally instead of the page scrolling. */
  flex: 0 0 auto;
`;

export const AccordionHeader = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${responsive.spacing.medium};
  width: 100%;
  padding: 0 ${responsive.spacing.medium};
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  color: inherit;
  min-height: 2.5rem;
  &:hover {
    background-color: ${colors.background.neutral.soft['100']};
  }
`;

export const AccordionChevronWrap = styled.span<{ $expanded: boolean }>`
  display: inline-flex;
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  transform: rotate(${({ $expanded }) => ($expanded ? '90deg' : '0deg')});
  transition: transform 0.15s ease;
`;

export const AccordionRule = styled.span`
  flex: 1 1 auto;
  height: 1px;
  min-width: 2rem;
  background: ${colors.background.neutral.soft['300']};
  align-self: center;
`;
